/**
 * Serviço de API para funcionalidades de administração
 * Endpoints protegidos por middleware sysadmin
 */

import { api } from '@/http';

export default {
    /**
     * Listar todos os usuários (para administração)
     * @param {object} filters - Filtros opcionais
     * @returns {Promise}
     */
    listUsers(filters = {}) {
        return api({
            url: '/users',
            method: 'get',
            params: filters
        });
    },

    /**
     * Listar todos os serviços
     * @returns {Promise}
     */
    listServices() {
        return api({
            url: '/service', // Assuming endpoint is /service based on user request context (/api/v1/service)
            method: 'get'
        });
    },

    /**
     * Criar novo usuário
     * @param {object} userData - Dados do usuário
     * @returns {Promise}
     */
    createUser(userData) {
        return api({
            url: '/users',
            method: 'post',
            data: userData
        });
    },

    /**
     * Editar usuário existente
     * @param {number} userId - ID do usuário
     * @param {object} userData - Dados a atualizar
     * @returns {Promise}
     */
    updateUser(userId, userData) {
        return api({
            url: `/users/${userId}`,
            method: 'put',
            data: userData
        });
    },

    /**
     * Inativar usuário (soft delete)
     * @param {number} userId - ID do usuário
     * @returns {Promise}
     */
    deleteUser(userId) {
        return api({
            url: `/users/${userId}`,
            method: 'delete'
        });
    },

    /**
     * Conceder acesso a um plano (Starter ou Premium)
     * @param {number} userId - ID do usuário
     * @param {string} expiresAt - Data de expiração (YYYY-MM-DD HH:mm:ss) ou null para permanente
     * @param {boolean} notifyUser - Se deve notificar o usuário por email
     * @param {string} profileSlug - Slug do perfil ('pro' ou 'starter'), default: 'pro'
     * @returns {Promise}
     */
    grantPro(userId, expiresAt, notifyUser = false, profileSlug = 'pro') {
        return api({
            url: '/users/grant-pro',
            method: 'post',
            data: {
                user_id: userId,
                expires_at: expiresAt,
                notify_user: notifyUser,
                profile_slug: profileSlug
            }
        });
    },

    /**
     * Estender prazo de acesso Pro de um usuário
     * @param {number} userId - ID do usuário
     * @param {string} newExpiresAt - Nova data de expiração (YYYY-MM-DD HH:mm:ss)
     * @returns {Promise}
     */
    extendPro(userId, newExpiresAt) {
        return api({
            url: '/users/extend-pro',
            method: 'post',
            data: {
                user_id: userId,
                new_expires_at: newExpiresAt
            }
        });
    },

    /**
     * Tornar acesso Pro permanente (sem data de expiração)
     * @param {number} userId - ID do usuário
     * @returns {Promise}
     */
    makeProPermanent(userId) {
        return api({
            url: `/users/${userId}/make-pro-permanent`,
            method: 'post'
        });
    },

    /**
     * Revogar acesso Pro (voltar para Starter)
     * @param {number} userId - ID do usuário
     * @returns {Promise}
     */
    revokePro(userId) {
        return api({
            url: `/users/${userId}/revoke-pro`,
            method: 'post'
        });
    }
};
